if (!window.AbstractaWishlist) {
  /*
   * wishlist.js — Abstracta Decor
   * Module 2 (Header): live-count only.
   *
   * Storage: localStorage key 'abstracta:wishlist', a JSON array of
   * product/variant IDs. This file's only job right now is to read that
   * key and keep the header icon's count badge in sync with it.
   *
   * window.AbstractaWishlist is exposed so a future module — "Add to
   * wishlist" buttons on product cards/pages — can push into the same
   * storage key without needing to know anything about the header's DOM.
   * That future module is out of scope for this Header section build.
   */
  var STORAGE_KEY = 'abstracta:wishlist';

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* Storage unavailable (private browsing, quota, etc.) — fail silently. */
    }
  }

  function updateBubble() {
    var bubble = document.querySelector('.wishlist-count-bubble');
    if (!bubble) return;
    var count = readWishlist().length;
    var countEl = bubble.querySelector('span[aria-hidden]');
    if (countEl) countEl.textContent = count;
    bubble.hidden = count === 0;
  }

  window.AbstractaWishlist = {
    get: readWishlist,
    add: function (id) {
      var list = readWishlist();
      if (list.indexOf(id) === -1) list.push(id);
      writeWishlist(list);
      updateBubble();
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
    },
    remove: function (id) {
      var list = readWishlist().filter(function (item) {
        return item !== id;
      });
      writeWishlist(list);
      updateBubble();
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
    },
    toggle: function (id) {
      var has = readWishlist().indexOf(id) !== -1;
      if (has) {
        this.remove(id);
      } else {
        this.add(id);
      }
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBubble);
  } else {
    updateBubble();
  }
}
